import { SkillGroup } from '@shared/models';

export const SKILL_GROUPS_SKELETON_DATA: SkillGroup[] = [
    {
        id: '1',
        title: '',
        skills: [
            {
                id: '1',
                title: '',
                modules: 0,
            },
            {
                id: '2',
                title: '',
                modules: 0,
            },
            {
                id: '3',
                title: '',
                modules: 0,
            },
        ],
    },
    {
        id: '2',
        title: '',
        skills: [
            {
                id: '1',
                title: '',
                modules: 0,
            },
            {
                id: '2',
                title: '',
                modules: 0,
            },
            {
                id: '3',
                title: '',
                modules: 0,
            },
        ],
    },
    {
        id: '3',
        title: '',
        skills: [
            {
                id: '1',
                title: '',
                modules: 0,
            },
            {
                id: '2',
                title: '',
                modules: 0,
            },
            {
                id: '3',
                title: '',
                modules: 0,
            },
        ],
    },
    {
        id: '4',
        title: '',
        skills: [
            {
                id: '1',
                title: '',
                modules: 0,
            },
            {
                id: '2',
                title: '',
                modules: 0,
            },
            {
                id: '3',
                title: '',
                modules: 0,
            },
        ],
    },
    {
        id: '5',
        title: '',
        skills: [
            {
                id: '1',
                title: '',
                modules: 0,
            },
            {
                id: '2',
                title: '',
                modules: 0,
            },
            {
                id: '3',
                title: '',
                modules: 0,
            },
        ],
    },
];
